<template>
  <div class="timoo-overview">
    <h1>Timoo</h1>
    <section class="summary" v-if="overview">
      <div class="card">
        <h2>{{ $t('nav.servicesOverview') }}</h2>
        <ul>
          <li v-for="s in overview.services" :key="s.key">
            <span class="dot" :class="{ on: s.active }"></span>
            {{ s.name }}
          </li>
        </ul>
      </div>
      <div class="card">
        <h2>{{ $t('nav.current') }}</h2>
        <div class="meter">
          <div class="meter-bar">
            <div
              class="meter-fill"
              :style="{ width: creditPct + '%' }"
              :aria-valuenow="creditPct"
              aria-valuemin="0"
              aria-valuemax="100"
              role="progressbar"
            />
          </div>
          <div class="meter-info">
            <div>{{ currency(overview.credito.balance) }} / {{ currency(overview.credito.max) }} {{ overview.credito.currency }}</div>
            <small>Threshold: {{ currency(overview.credito.threshold) }}</small>
          </div>
        </div>
      </div>
      <div class="card" v-if="overview.notices && overview.notices.length">
        <h2>Notices</h2>
        <ul>
          <li v-for="n in overview.notices" :key="n.id">{{ n.text }}</li>
        </ul>
      </div>
    </section>
    <section v-else class="loading">Loading...</section>
  </div>
</template>

<script>
import { TimooService } from '@/services/TimooService';

export default {
  name: 'TimooOverview',
  data() {
    return {
      overview: null,
    };
  },
  computed: {
    creditPct() {
      if (!this.overview) return 0;
      const { balance, max } = this.overview.credito;
      return Math.round((balance / max) * 100);
    },
  },
  methods: {
    async load() {
      this.overview = await TimooService.getOverview();
    },
    currency(v) {
      return Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped>
.timoo-overview {
  padding: 16px;
}
.card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.meter {
  display: flex;
  align-items: center;
  gap: 12px;
}
.meter-bar {
  flex: 1;
  height: 12px;
  background: #f0f2f5;
  border-radius: 999px;
  overflow: hidden;
}
.meter-fill {
  height: 100%;
  background-image: linear-gradient(90deg, #0e73ff, #4cc3ff);
}
.meter-info {
  min-width: 220px;
}
.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ccc;
  margin-right: 8px;
}
.dot.on { background: #2ecc71; }
.loading { color: #666; }
</style>
